
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.NextStop = {

  template: (data) => {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.nextStop.message'),
                  attributes: {
                    class: 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
            key: data.key,
          },
        },
      ],
    };
  },

  assignParameter: () => {},

  retrieveParameter: () => {
    return JSON.stringify({
      noAttributes: true,
    });
  }

};
